<template>
  <div class="slides_counter">
    <span>
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {};
</script>

<style lang="scss">
.slides_counter {
  position: absolute;
  right: 14px;
  top: 12px;
  color: #fff;
  font-size: 1em;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    right: 5px;
    top: 0;
    height: 0;
    width: 0;
    border-radius: 20px;
    box-shadow: 0 0 45px 40px rgba(0, 0, 0, 0.2);
  }

  span {
    position: relative;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  }
}

@media screen and (orientation: landscape) {
  .slides_counter {
    right: 20px;
    top: 20px;
    @supports (left: 15px) {
      right: calc(env(safe-area-inset-right) / 4 + 20px);
      top: calc(env(safe-area-inset-right) / 4 + 20px);
    }
  }
}
</style>
